import { useState, useEffect, forwardRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import PropTypes from 'prop-types';
import styledComponents from "styled-components";

import {
  Box,
  CircularProgress,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  InputAdornment,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import PhoneInput from 'react-phone-input-2';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TelegramIcon from '@mui/icons-material/Telegram';


const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Profile = () => {
    
    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const [profile, setProfile] = useState({});
    const [authData, setAuth] = useState({});
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };
    const [wa, setWa] = useState(null);
    const [isLoading, setLoading] = useState(true);

    const changeWa = (value) =>  {
        setWa(value);
    };
    
    useEffect(() => {
        
        const getProfile = async () => {
            try {
              const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/profile`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
              });
              setProfile(getData.data.result);
              setWa(getData.data.result.whatsapp);
            } catch (err) {
              console.log(err);
            }
        };

        const auth = async () => {
            try {
                const me = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`,
                  {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  }
                );
                setAuth(me.data.result);
            } catch (err) {
              console.log(err);
    
            }
        };

        const init = async () => {
            await getProfile();
            await auth();
            await setLoading(false);
        };

        init();

    }, [])

    return (
        <Container>
            <Snackbar
                open={openAlert}
                autoHideDuration={2500}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                key={'top' + 'center'}
            >
                <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            {!isLoading && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Formik
                            initialValues={{
                                namamitra: null,
                                namaagen: null,
                                whatsapp: null,
                                telegraam: null,
                                instagram: null,
                                facebook: null,
                                email: null
                            }}
                            validate={values => {
                                const errors = {};
                                return errors;
                            }}
                            onSubmit={async (values, { setSubmitting }) => {

                                if(wa !== profile.whatsapp) values.whatsapp = wa;

                                const filteredVal = Object.keys(values).reduce((newObj, key) => {
                                    const value = values[key];
                                    if (value !== null) {
                                        newObj[key] = value;
                                    }
                                    return newObj;
                                }, {});
                                if (Object.keys(filteredVal).length === 0) {
                                    setAlertStatus('warning');
                                    setAlertMessage('Tidak ada perubahan')
                                    setOpenAlert(true);
                                    setSubmitting(false);
                                } else {
                                    console.log(filteredVal);
                                    try {
                                        await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/profile/update`, filteredVal, {
                                            headers: {
                                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                            }
                                        });
                                        
                                        const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/profile`, {
                                            headers: {
                                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                            }
                                        });
                                        setProfile(getData.data.result);

                                        setAlertStatus('success');
                                        setAlertMessage('Update profile berhasil');
                                        setOpenAlert(true);
                                        setSubmitting(false);

                                    } catch (err) {
                                        console.log(err);
                                        setSubmitting(false);
                                    }
                                }
                            }}
                        >
                            {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sx={{ textAlign: 'left' }}>
                                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                                Profile
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                id="outlined-multiline-flexible"
                                                size="small"
                                                required
                                                fullWidth
                                                label="Nama Mitra"
                                                onChange={handleChange}
                                                name={authData.role === 'distributor' ? 'namamitra' : 'namaagen'}
                                                defaultValue={authData.role === 'distributor' ? profile.namamitra : profile.namaagen}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                                No Whatsapp
                                            </InputLabel>
                                            <PhoneInput
                                                disableDropdown
                                                countryCodeEditable={false}
                                                name="whatsapp"
                                                country={'id'}
                                                onlyCountries={['id']}
                                                value={wa}
                                                inputStyle={{ width: '100%', height: '3em' }}
                                                onChange={changeWa}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                id="outlined-multiline-flexible"
                                                size="small"
                                                fullWidth
                                                label="Telegram"
                                                onChange={handleChange}
                                                name="telegram"
                                                InputProps={{
                                                    startAdornment: (
                                                    <InputAdornment position="start">
                                                        <TelegramIcon />
                                                    </InputAdornment>
                                                    )
                                                }}
                                                defaultValue={profile.telegram}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                id="outlined-multiline-flexible"
                                                size="small"
                                                fullWidth
                                                label="Facebook"
                                                onChange={handleChange}
                                                name="facebook"
                                                InputProps={{
                                                    startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FacebookIcon />
                                                    </InputAdornment>
                                                    )
                                                }}
                                                defaultValue={profile.facebook}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                id="outlined-multiline-flexible"
                                                size="small"
                                                fullWidth
                                                label="Instagram"
                                                onChange={handleChange}
                                                name="instagram"
                                                InputProps={{
                                                    startAdornment: (
                                                    <InputAdornment position="start">
                                                        <InstagramIcon />
                                                    </InputAdornment>
                                                    )
                                                }}
                                                defaultValue={profile.instagram}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                id="outlined-multiline-flexible"
                                                type="email"
                                                size="small"
                                                required
                                                fullWidth
                                                label="Email"
                                                disabled
                                                onChange={handleChange}
                                                name="email"
                                                defaultValue={profile.email}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                            <Button variant="contained" type="submit" disabled={isSubmitting}>Simpan perubahan</Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            )}
        </Container>
    )
}

export default Profile
